import { Component, computed, input } from '@angular/core';
import { NetzzuordnungenImportSnapshot } from '../../../domain/model/netzzuordnungen-import-snapshot.model';
import { MaterialModule } from '../../../common/material/material.module';
import { PipeModule } from '../../../common/pipe/pipe.module';
import { Leistungseinheit } from '../../../domain/model/leistungseinheit';

type RowType = 'default' | 'exceededBruttoleistung' | 'ungueltigeAnlage';

type LimitType = 'ungueltige-netzzuordnungen' | 'ungueltige-anlagen-by-stadtwerke' | 'bruttoleistung-by-stadtwerke' | '';

interface ReportRow {
    rowType: RowType;
    stepIcon: string
    limitType: LimitType;
    stepName: string;
    limit: number;
    count: number;
    isValid: boolean;
    isDisabled: boolean;
}

@Component({
    selector: 'tnb-netzzuordnung-import-report',
    standalone: true,
    imports: [
        MaterialModule,
        PipeModule,
    ],
    templateUrl: './netzzuordnung-import-report.component.html',
    styleUrl: './netzzuordnung-import-report.component.scss',
})
export class NetzzuordnungImportReportComponent {
    netzzuordungImport = input<NetzzuordnungenImportSnapshot>();

    reportRows = computed(() => {
        const report = this.netzzuordungImport();

        const isUngultigeNetzzuordnungenValid = report.countUngueltigeNetzzuordnungen <= report.limitUngueltigeNetzzuordnungen;
        const isUngultigeAnlagenByStadtwerkeValid = report.countUngueltigeAnlagenByStadtwerke <= report.limitUngueltigeAnlagenByStadtwerke;
        const isBruttoleistungByStadtwerkeValid = report.exceededBruttoleistungByStadtwerke.length == 0;

        const result: Array<ReportRow> = [
            {
                rowType: 'default',
                stepIcon: 'looks_one',
                stepName: 'Ungültige Netzzuordnungen',
                count: report.countUngueltigeNetzzuordnungen,
                limit: report.limitUngueltigeNetzzuordnungen,
                limitType: 'ungueltige-netzzuordnungen',
                isValid: isUngultigeNetzzuordnungenValid,
                isDisabled: false,
            },
            {
                rowType: 'default',
                stepIcon: 'looks_two',
                stepName: 'Ungültige Anlagen/Stadtwerk',
                count: report.countUngueltigeAnlagenByStadtwerke,
                limit: report.limitUngueltigeAnlagenByStadtwerke,
                limitType: 'ungueltige-anlagen-by-stadtwerke',
                isValid: isUngultigeAnlagenByStadtwerkeValid,
                isDisabled: false,
            },
            ... report.ungueltigeAnlagen.map((ungultigeAnlage) => ({
                rowType: 'ungueltigeAnlage',
                stepIcon: '',
                stepName: ungultigeAnlage.stadtwerkeId,
                count: ungultigeAnlage.countAnlagen,
                limit: 0,
                limitType: '',
                isValid: true,
                isDisabled: false,
            }) as ReportRow),
            {
                rowType: 'default',
                stepIcon: 'looks_3',
                stepName: 'Bruttonennleistung/Stadtwerk',
                count: report.countBruttoleistungByStadtwerke,
                limit: report.limitBruttoleistungByStadtwerke,
                limitType: 'bruttoleistung-by-stadtwerke',
                isValid: isBruttoleistungByStadtwerkeValid,
                isDisabled: false,
            },
            ... report.exceededBruttoleistungByStadtwerke.map((exceededBruttoleistung) => ({
                rowType: 'exceededBruttoleistung',
                stepIcon: '',
                stepName: exceededBruttoleistung.stadtwerkeId,
                count: exceededBruttoleistung.exceededBruttoleistung,
                limit: 0,
                limitType: '',
                isValid: true,
                isDisabled: false,
            }) as ReportRow),
        ];

        return result;
    });

    public displayedColumns = [
        'step',
        'limit',
        'count',
    ];
    protected readonly Leistungseinheit = Leistungseinheit;
}
